// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "appointment_resource".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { appointmentResourceSourceValues } from '@borradh-workspace/labels';
/** Response atom for the "appointment_resource" table (1:1 with a DB row, on the wire). */
export const appointmentResourceAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    appointmentId: z.string(),
    resourceId: z.string(),
    startDate: z.string().datetime(),
    endDate: z.string().datetime(),
    turnaroundMinutes: z.number(),
    source: z.enum(appointmentResourceSourceValues),
    allowOverlap: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=appointmentResource.js.map